module.exports = __webpack_public_path__ + "static/media/proj17_img2.218782cc.jpg";